import { constants } from '@yola/subscription-manager-js';
import orderConfigurations from './order-configurations';

const { hostingPackageFeatureNames: features, ecommercePlanFeatureNames: ecommerceFeatures } =
  constants;

const order = [
  features.SITE_COUNT,
  features.AI,
  features.SITE_STORAGE_QUOTA,
  features.UPLOAD_SIZE,
  features.PAGE_COUNT,
  features.FREE_DOMAIN_PROMO,
  features.CUSTOM_DOMAIN,
  features.MULTILANGUAGE_SITE,
  features.PARTNER_ADS,
  features.CUSTOM_CODE,
  features.PREMIUM_ICONS_PAYWALL,
  features.PREMIUM_BLOCKS_AND_WIDGETS,
  features.PREMIUM_STOSK_IMAGES,
  features.PREMIUM_WEBSITE_TEMPLATES,
  features.PREMIUM_TEXT_DECORATIONS,
  features.PREMIUM_COMPOSITE_GROUP,
  features.ADVANCED_WEBSITE_CUSTOMIZATION,
  features.CUSTOMER_CARE,
  features.LEAD_CAPTURE_FORMS,
  features.FIELDS_PER_FORM,
  features.FORM_SUBMISSIONS,
  features.FORM_ATTACHMENTS,
  features.ANALYTICS,
  features.AI_SITE_WIZARD,
  features.AI_DESIGN_ASSISTANT,
  features.AI_BLOCK_GENERATOR,
  features.AI_TEXT_ASSISTANT,
  features.AI_LOCALIZATION,
  features.SEARCH_ENGINE_OPTIMIZATION,
  features.AUTOMATIC_SITE_SPEED_OPTIMIZATION,
  features.AUTOMATIC_IMAGE_OPTIMIZATION,
  features.REDIRECTS,
  features.SITEMAP_CONTROLS,
  features.TRAFFIC_BUILDER,
  features.DDOS_PROTECTION,
  features.GDRP_AND_CCPA_COMPLIANCE,
  features.PRIVATE_REGISTRATION,
  features.FREE_UNLIMITED_SSL,
  features.UNLIMITED_SITE_BACKUPS,
  features.PASSWORD_PROTECTED_PAGES,
  features.WEBSITE_EXPORT,
];

const ecommerceOrder = [
  ecommerceFeatures.PRODUCT_LIMIT,
  ecommerceFeatures.CATEGORIES,
  ecommerceFeatures.E_GOODS_MAX_SIZE,
  ecommerceFeatures.GOOGLE_SALES,
  ecommerceFeatures.FACEBOOK_SALES,
  ecommerceFeatures.INSTAGRAM_SALES,
  ecommerceFeatures.AMAZON_SALES,
  ecommerceFeatures.EBAY_SALES,
  ecommerceFeatures.FACEBOOK_ADVERTISING,
  ecommerceFeatures.GOOGLE_ADVERTISING,
  ecommerceFeatures.TIKTOK_ADVERTISING,
  ecommerceFeatures.INVENTORY_TRACKING,
  ecommerceFeatures.ABANDONED_CART_RECOVERY,
  ecommerceFeatures.MULTILINGUAL,
  ecommerceFeatures.TAX_CALCULATIONS,
  ecommerceFeatures.MARKETING_EMAILS,
  ecommerceFeatures.PRE_ORDERS,
  ecommerceFeatures.SUBSCRIPTIONS,
  ecommerceFeatures.GIFT_CARDS,
  ecommerceFeatures.COUPONS,
];

const sortByFeatureId = (availableFeatures, isEcommerce) => {
  const priorities = orderConfigurations.get(isEcommerce ? ecommerceOrder : order);

  return availableFeatures.sort((a, b) => priorities[a.id] - priorities[b.id]);
};

export default sortByFeatureId;
